import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a889e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar bar-short" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar bar-medium" }, null, -1))
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "nav-links" }

import NavigationLinks from '@/components/Navbar/NavigationLinks.vue';
import { useThemeStore } from '@/stores/theme';
import { useNavMenuStore } from '@/stores/navMenu';
import { useCursorHover } from '@/directives/useCursorHover';
import { DarkTheme, LightTheme } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const themeStore = useThemeStore();

const navMenuStore = useNavMenuStore();

const vCursorHover = useCursorHover();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["navigation", { 'navigation-dark-theme': _unref(themeStore).theme === _unref(DarkTheme),
                  'navigation-light-theme': _unref(themeStore).theme === _unref(LightTheme) }])
  }, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      class: "nav-hamburger-toggler",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(navMenuStore).open();}),
      "aria-label": "Hamburger"
    }, _hoisted_4)), [
      [_unref(vCursorHover)]
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(NavigationLinks, { alignment: "horizontal" })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["background-blocking-content", { 'background-blocking-content-visible': _unref(navMenuStore).opened }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(navMenuStore).close();})
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["nav-links-mobile-menu", { 'active': _unref(navMenuStore).opened }])
    }, [
      _createVNode(NavigationLinks, { alignment: "vertical" })
    ], 2)
  ], 2))
}
}

})